export const profileElement = (theme) => ({
    root: {
        [theme.breakpoints.up("md")]: {
            padding: theme.spacing(2, 0, 2, 3),
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(3, 0, 2, 4),
        },
    },
    verticalDivider: {
        [theme.breakpoints.down("sm")]: {
            borderBottom: `1px solid white`,
        },
    },
    horizontalDivider: {
        [theme.breakpoints.up("md")]: {
            borderLeft: `1px solid white`,
        },
    },
    label: {
        fontSize: "16px",
        fontWeight: "normal",
        paddingBottom: "8px",
        color: theme.customPalette.neutralGy05,
    },
    value: {
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: 1,
        wordBreak: "break-word",
        color: theme.customPalette.neutralGy05,
    },
    panelActionsClose: {
        position: "absolute",
        right: 0,
    },
});
